import { render } from "./quiz1_2.vue?vue&type=template&id=7bfcfb0f&scoped=true"
import script from "./quiz1_2.vue?vue&type=script&lang=js"
export * from "./quiz1_2.vue?vue&type=script&lang=js"

import "./quiz1_2.vue?vue&type=style&index=0&id=7bfcfb0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bfcfb0f"]])

export default __exports__